/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import { React, useCallback, useEffect, useState } from "react";

import { Button, Modal, Select } from "antd";
import { useQueryClient } from "react-query";

import { useClient } from "../../../hooks/ClientProvider";
import { fetchClientHorizon } from "../../../hooks/useClientHorizon";
import api from "../../../services/api";
import { notifyError, notifySucces } from "../../../utils/notifications";
import * as S from "./styles";
import DSButton from "../../../components/DSButton";
import designSystemColors from "../../../styles";

const { Option } = Select;

function ModalChangeInvoiceDueDate({
  open,
  closeModal,
  cicloValue,
  dateCiclos,
  value,
  reloadAllInvoices,
}) {
  const [dateCiclo, setDateCiclo] = useState(cicloValue);
  const [newDate, setNewDate] = useState("");
  const [isLoadingDueDateChange, setIsLoadingDueDateChange] = useState(false);

  const [erro, setErro] = useState("");

  const queryClient = useQueryClient();
  const { client } = useClient();

  useEffect(() => {
    if (erro !== "") {
      notifyError(`Não foi possível realizar alteração: ${erro}`);
      setErro("");
    }
  }, [erro]);
  const clientId = client.client.id;
  const ifChangeCiclo = useCallback(async () => {
    try {
      return await fetchClientHorizon(queryClient, clientId, { force: true });
    } catch (error) {
      console.error("Falha ao consultar ciclo do cliente");
      return undefined;
    }
  }, [clientId, queryClient]);

  // eslint-disable-next-line consistent-return
  async function handleChangeDay() {
    setIsLoadingDueDateChange(true);
    const data = await ifChangeCiclo();
    let novoCic = await dateCiclos.filter((d) => d.id === newDate);
    novoCic = novoCic[0]?.diaVencimento;
    const dataVencimentoAnterior = client?.information?.diaVencimento;

    if (novoCic === undefined || novoCic === null) {
      setIsLoadingDueDateChange(false);
      return notifyError(
        "Por favor, selecione uma data de vencimento.",
        "ERROR_HIGHLIGHT",
        true,
        true
      );
    }

    if (novoCic === dataVencimentoAnterior) {
      setIsLoadingDueDateChange(false);
      return notifyError(
        "Por favor, selecione uma data de vencimento diferente da atual.",
        "ERROR_HIGHLIGHT",
        true,
        true
      );
    }

    if (!data) {
      setIsLoadingDueDateChange(false);
      return undefined;
    }

    if (data.faturaFutura === null) {
      setErro("Cliente possui valores de fatura em aberto");
      closeModal();
    } else {
      try {
        await api.patch("change_invoice_due_date", {
          client_id: client.client.id,
          idciclovencimento: newDate,
          cicloAnterior: dataVencimentoAnterior,
          novoCiclo: novoCic,
        });
        notifySucces("Data de vencimento alterada com sucesso");
        reloadAllInvoices?.();
        closeModal();
      } catch (error) {
        notifyError(
          "Erro! O cliente teve seu ciclo alterado nos últimos 30 dias ou possui alguma fatura em aberto.",
          "ERROR_HIGHLIGHT"
        );
      } finally {
        setIsLoadingDueDateChange(false);
      }
    }
  }
  async function handleGoBack() {
    closeModal();
  }

  return (
    <Modal visible={open} width={600} onCancel={closeModal}>
      <S.ModalContainer>
        <S.ModalTitle>
          <h1>Alterar data de vencimento</h1>
        </S.ModalTitle>

        <p />
        <p />
        <span>Digite aqui o dia desejado</span>
        <Select defaultValue={dateCiclo} onChange={setNewDate}>
          <Option value="0">Selecione</Option>
          {dateCiclos.map((dateCiclo) => (
            <Option value={dateCiclo.id} key={dateCiclo.id}>
              {dateCiclo.diaVencimento}
            </Option>
          ))}
        </Select>

        <S.BtnRow>
          <div className="btn-content">
            <S.ButtonContainerCancel>
              <DSButton
                buttonText="Cancelar"
                buttonType="secondary"
                isCancelType
                onClick={() => handleGoBack()}
              >
                Cancelar
              </DSButton>
            </S.ButtonContainerCancel>
          </div>
          <div className="btn-content">
            <S.ButtonContainerDueDate>
              <DSButton
                buttonText="Concluir"
                buttonType="secondary"
                isLoading={isLoadingDueDateChange}
                onClick={() => handleChangeDay()}
                disabled={newDate === "0" || newDate === ""}
                style={{
                  backgroundColor:
                    newDate === "0" || newDate === ""
                      ? "gray"
                      : designSystemColors.secondaryButtons,
                }}
              >
                Concluir
              </DSButton>
            </S.ButtonContainerDueDate>
          </div>
        </S.BtnRow>
      </S.ModalContainer>
    </Modal>
  );
}
export default ModalChangeInvoiceDueDate;
